import Service from '@ember/service';

/*
 * - Right now register-partners-js uses a dual api.
 * - Backend wants to unify everything into register-js api.
 * - The legacy flow uses partners-api (isPartnerService === true).
 * - To use the correct API, in the route roots, when we trigger the network request to fetch the organization
 *   details, if it errors with 404 means we must use register-js api.
 */
export default class APIFlowManager extends Service {
  // By default, the first API call is to partners-api; a 404 indicates that we need to use register-js api
  isPartnersService = true;
}
